import React, { useRef } from 'react';
import FAQList, { FAQItem } from '../ui/FAQList';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

interface AboutFaqProps {
  title: string;
  items: FAQItem[];
}

const FAQ = ({ title, items }: AboutFaqProps) => {


  const sectionRef = useRef(null);      
  const titleRef = useRef(null);
  const containerRef = useRef(null)

  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {


      gsap.fromTo(containerRef.current, {
        y: '13rem'
      },
          {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom", 
          end: "top 70%",  
          scrub: 0.1,  
        },
      });

      gsap.fromTo(titleRef.current, { opacity: 0 }, {
        opacity: 1,

        duration: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      });


    });

    return () => mm.revert();
  }, {scope: sectionRef});



  return (
    <section ref={sectionRef} className="container-padding container-max flex-col text-center  py-[4rem] md:py-[6rem] lg:py-[7rem] xl:py-[8rem]">
      <div ref={containerRef}>

      <h2
      ref={titleRef}
        className="mb-[1.6rem] heading-3 [&>.selected]:italic [&>.selected]:text-dusty-green-dark"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <FAQList items={items} />
      </div>

    </section>
  );
};

export default FAQ;